import { h } from "preact";
import { useSelector } from "react-redux";

import i18n from "../i18n";
import { selectTasks } from "../store";
import Tag from "./Tag.jsx";

export default function TaskLink({ id, ...props }) {
  const tasks = useSelector(selectTasks);

  if (!tasks.find((t) => t.id === id)) {
    return null;
  }

  return (
    <Tag to={`/tasks/${encodeURIComponent(id)}`} class={props.class}>
      {i18n.t(`tasks.${id}.tagline`)}
    </Tag>
  );
}
